import { css } from 'linaria';

export const signupCard = css`
  && {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    column-gap: 32px;

    @media (--to-desktop) {
      flex-direction: column-reverse;
      padding: 32px;
      column-gap: 0;
      row-gap: 16px;
    }

    @media (--only-mobile) {
      padding: 32px 24px;
    }
  }
`;

export const signupCardHeader = css`
  && {
    @media (--only-tablet) {
      font-size: 20px;
      line-height: 26px;
    }

    @media (--only-mobile) {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const signupCardButton = css`
  margin-top: auto;

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const signupCardLogo = css`
  && {
    @media (--to-desktop) {
      inset: 32px auto auto 24px;
      width: 80px;
      height: 80px;
    }
  }
`;

export const orderSectionCardGrid = css`
  && {
    @media (--only-mobile) {
      grid-template-rows: 1fr;
    }
  }
`;

export const signupCardTextWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;

  @media (--only-mobile) {
    height: auto;
  }
`;

export const orderSectionCardActions = css`
  @media (--only-mobile) {
    width: 100%;
  }
`;
